enum Route {
  HOME = "/",
  SKILLS = "/skills",
  EXPERIENCE = "/experience",
  EDUCATION = "/education",
  PROJECTS = "/projects",
  CONTACT = "/contact",
}

export default Route;
